import {api} from '../../../system/api';

export default {
	updateStatusInventory: (params) => api.put(`inventories/${params.id}/update-status`, {...params}),
};
